import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { DATA_ROOM_ROOT_FOLDER } from 'data/global';
import { getDataRoomRoute } from 'utils';
import LinkToIcon from 'icons/LinkTo.icon';
import FolderIcon from 'icons/Folder.icon';
import HomeIcon from 'icons/Home.icon';

import './DataRoomNodeCurrentLocation.styles.scss';

export type CurrentLocation = {
  parentId?: string | null; // no parrentId -> root folder
  parentName?: string; // no parrentName -> 'Files'
} | null;

type DataRoomNodeCurrentLocationProps = {
  className?: string;
  dataRoomId: string;
  label?: string;
  currentLocation: CurrentLocation;
  onLinkClick?: () => void;
  onCurrentLocationClick?: (currentLocation: CurrentLocation) => void;
};

const DataRoomNodeCurrentLocation: React.FC<
  DataRoomNodeCurrentLocationProps
> = (props) => {
  const {
    className,
    dataRoomId,
    currentLocation,
    label,
    onLinkClick,
    onCurrentLocationClick,
  } = props;

  const classes = classNames('data-room-node-current-location', className);

  const { t } = useTranslation();

  if (!currentLocation) return null;

  const { parentId, parentName } = currentLocation;

  const to = `${getDataRoomRoute(dataRoomId, 'documents')}/${parentId || ''}`;

  return (
    <div className={classes}>
      {label && <p>{label}</p>}

      <div
        className={classNames({ clickable: !!onCurrentLocationClick })}
        onClick={() => onCurrentLocationClick?.({ parentId, parentName })}
      >
        {parentId ? <FolderIcon className="folder-icon" /> : <HomeIcon />}
        <p>{parentName || t(DATA_ROOM_ROOT_FOLDER)}</p>
      </div>

      <Link
        to={to}
        onClick={(e) => {
          e.stopPropagation();
          onLinkClick();
        }}
      >
        <LinkToIcon />
      </Link>
    </div>
  );
};

export default DataRoomNodeCurrentLocation;
